import React, { useState } from 'react';
import { isElectron } from '../../../helpers/EnvironmentFlags/EnvironmentFlags';
import { SearchForm } from './SearchForm/SearchForm';
import { EmailSearch } from './EmailSearch';
import { isNumeric } from '../../../helpers/Number';
import { Lookup, IProps as ILookupProps } from './Lookup';
import { SearchFormProps } from './SearchForm/SearchForm.types';

interface IProps extends SearchFormProps, ILookupProps { }

export const Search: React.FC<IProps> = ({ onAppointmentSelected, onNotListed }) => {
    const [showSearchForm, setShowSearchForm] = useState<boolean>(false);
    const [email, setEmail] = useState<string>('');
    const [phone, setPhone] = useState<string>('');

    const onAlternateSearch = (phoneNumberOrEmail: string) => {
        if (isNumeric(phoneNumberOrEmail)) {
            setPhone(phoneNumberOrEmail);
        }
        else {
            setEmail(phoneNumberOrEmail);
        }

        setShowSearchForm(true);
    };

    return (
        (!isElectron() && !showSearchForm && <EmailSearch onAlternateSearch={onAlternateSearch} />) ||
        (!isElectron() && (
            <SearchForm
                initialEmail={email}
                initialPhone={phone}
                onAppointmentSelected={onAppointmentSelected}
                onNotListed={onNotListed}
            />
        )
        ) || (
            <Lookup onAppointmentSelected={onAppointmentSelected} onNotListed={onNotListed} />
        )
    );
};
